import React from "react";
import { Card, CardMedia, CardContent, Typography, Button, Box } from "@mui/material";
import { motion } from "framer-motion";

const CompactLife360Card = () => {
  return (
    <></>
    // <motion.div
    //   whileHover={{ scale: 1.05 }}
    //   transition={{ duration: 0.3 }}
    // >
    //   <Card sx={{ display: 'flex', alignItems: 'center', maxWidth: 280, boxShadow: 3, borderRadius: 2, p: 1, border: 1, borderColor: 'grey.300', overflow: 'hidden' }}>
    //     {/* Image Section */}
    //     <CardMedia
    //       component="img"
    //       image="/your-image-path.jpg" // Replace with actual image path
    //       alt="Life360 App"
    //       sx={{ width: 80, height: 80, borderRadius: 1, objectFit: 'cover' }}
    //     />
        
    //     {/* Content Section */}
    //     <CardContent sx={{ flex: 1, pl: 1, pr: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
    //       <Typography variant="subtitle2" fontWeight="bold" color="text.primary" noWrap>
    //         Get <span style={{ color: '#1976d2' }}>Life360</span>
    //       </Typography>
    //       <Typography variant="caption" color="text.secondary" noWrap>
    //         Super app for all your car needs
    //       </Typography>
    //       <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.3, mt: 0.5 }}>
    //         <Typography variant="body2" color="text.secondary" fontSize={10}>✔ Car care</Typography>
    //         <Typography variant="body2" color="text.secondary" fontSize={10}>✔ Repair</Typography>
    //         <Typography variant="body2" color="text.secondary" fontSize={10}>✔ Emergency Services</Typography>
    //         <Typography variant="body2" color="text.secondary" fontSize={10}>✔ Real-time tracking</Typography>
    //       </Box>
    //       <Button variant="contained" color="warning" size="small" sx={{ mt: 1, textTransform: 'none', fontSize: 10, fontWeight: 'bold', borderRadius: 1 }}>
    //         ₹ 4999/year
    //       </Button>
    //     </CardContent>
    //   </Card>
    // </motion.div>
  )
};

export default CompactLife360Card;
